import { render, staticRenderFns } from "./HealthCheck25Register.vue?vue&type=template&id=381134b5&scoped=true&"
import script from "./HealthCheck25Register.vue?vue&type=script&lang=js&"
export * from "./HealthCheck25Register.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck25Register.vue?vue&type=style&index=0&id=381134b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381134b5",
  null
  
)

export default component.exports